import React from 'react'
import css from './style.scss'
import moment from 'moment';
import cn from 'classnames';
import DownloadIcon from 'react-icons/lib/md/file-download';
export default ({period_end, period_start, amount, date, url, paid})=>{
  return (
    <div className={css.invoice}>
      <div className={css.date}> {moment(date).format('MMM YYYY')}</div>
      <div className={cn(css.status, paid ? css.paid : "")}>{paid ? "Paid" : "Pending"}</div>
      <div className={css.amount}>€{amount/100}</div>
      <a target="_blank" href={url}><DownloadIcon size={24}/></a>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/settings/invoices/invoice.js